import React from 'react'
import ComputerAppointmentForm from './ComputerAppointmentForm'

export default function ComputerCreateAppointmentPage ({ box, onFinishFailed, onFinish, loading }) {
  return (
    <ComputerAppointmentForm box={box} onFinishFailed={onFinishFailed} onFinish={onFinish} loading={loading} />
  )
}
